import React from 'react';
import { IOSSwitch } from 'src/components/SwitchIos';
import { translations } from 'src/constants/translations';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { IMarketplaceToolTip } from 'src/components/profileComponents/Marketplace/types';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import { useStyles } from './styles';

interface Props {
  item: IMarketplaceToolTip | null,
  lang: string,
  onChange: (item: IMarketplaceToolTip) => void,
}

export const InfoTag: React.FC<Props> = ({ item, lang, onChange }) => {
  const styles = useStyles();
  return (
    <div className={styles.infoTagWrapper}>
      <div className={styles.infoTagSwitchWrapper}>
        <span>{translations.infoTag}</span>
        <IOSSwitch
          name="checkedInfrastructure"
          defaultChecked={!!item?.isActive}
          onChange={(e: any) => {
            if (item) {
              onChange({ ...item, isActive: e.target.checked });
            }
          }}
        />
      </div>
      <BoxFormTextField
        label={translations.informationalTegText}
        name="conversionRate"
        defaultValue={String(item?.text?.[lang] || '')}
        onChange={(event) => {
          if (item) {
            onChange(updateTranslatedField(item, 'text', lang, event.target.value));
          }
        }}
      />
    </div>
  );
};
